import { axiosApi } from '@/config';
import { PaginationResponse } from '@/modules/Products/interfaces';

export interface VatData {
	id: string;
	value: number;
	createdAt: string;
	updatedAt: string;
}

export interface VatResponse {
	dataVat: VatData[];
	pagination: PaginationResponse;
}

export const getAllVat = async (): Promise<VatResponse> => {
	try {
		const response = await axiosApi.get(`/vat`);
		return response.data;
	} catch (error) {
		console.error('Error fetching vat:', error);
		throw error;
	}
};
